import Container from '@mui/material/Container';
import React from 'react';

/**
 * メッセージ通知ページ Component
 */
const NotifyMessagePage = (props) => {
  const { isModalPage, children, ...other } = props;
  return (
    <Container className={`d-flex justify-content-center align-items-center ${isModalPage ? 'mt-1' : 'mt-5'} flex-column`} {...other}>
      {children}
    </Container>
  );
};
export default NotifyMessagePage;